import {
  ResourceFiltersWithAction,
  ResourceType,
} from "@/services/cloudchipr.api";

export const generateWorkflowsResourceFilter = (
  parentResourceType: ResourceType,
  resourceType: ResourceType,
  value: string[],
): ResourceFiltersWithAction[] => [
  {
    filter: {
      type: parentResourceType,
      filter_groups: [0],
      operators: ["and"],
      filter_items: [
        {
          type: resourceType,
          filter: {
            key: "provider_unique_identifier",
            operator: "in",
            value: value,
          },
        },
      ],
    },
  },
];
